import styled from "styled-components";
import Button from "../../../../bootstrap/Button";

export const CardWrapper = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

export const SingleCard = styled.div`
  background: white;
  border: 1px solid #eef2f5;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  
  &:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
    border-color: ${props => props.activeColor || "#1FBA30"};
  }

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const MainRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.5fr 1fr;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 1024px) {
    grid-template-columns: 100%;
    gap: 20px;
  }
`;

export const OperatorSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  
  h4 {
    font-size: 16.5px;
    font-weight: 800;
    color: #0f172a;
    margin: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    line-height: 1.3;
  }
  
  .coach-number {
    font-size: 11px;
    font-weight: 700;
    color: #e11d48;
    background: #fff1f2;
    padding: 2px 6px;
    border-radius: 4px;
  }
  
  .bus-type {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
  }
  
  .rating-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #fef3c7;
    color: #d97706;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11.5px;
    font-weight: 700;
    width: fit-content;
    
    svg {
      width: 12px;
      height: 12px;
      fill: currentColor;
    }
  }
`;

export const TimelineSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const TimeNode = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 90px;
  text-align: ${props => props.align || "center"};
  
  .time {
    font-size: 16px;
    font-weight: 800;
    color: #0f172a;
  }
  
  .station {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    margin-top: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }
`;

export const JourneyLine = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  .duration {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 4px;
  }
  
  .line-container {
    width: 100%;
    position: relative;
    height: 12px;
    display: flex;
    align-items: center;
  }
  
  .line {
    width: 100%;
    border-top: 2px dashed #cbd5e1;
  }
  
  .bus-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 0 8px;
    
    svg {
      width: 15px;
      height: 15px;
      fill: #94a3b8;
    }
  }
`;

export const BookingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  
  @media (max-width: 1024px) {
    align-items: flex-start;
  }
  
  .price {
    font-size: 20px;
    font-weight: 800;
    color: ${props => props.priceColor || "#1FBA30"};
    display: flex;
    align-items: center;
    gap: 2px;
  }
  
  .seats-left {
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 4px;
    span {
      color: #e11d48;
    }
  }
`;

export const BookingBtn = styled(Button)`
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-radius: 6px !important;
  font-size: 13.5px;
  padding: 10px 24px;
  border: none;
  width: 100%;
  cursor: pointer;
  background: ${props => props.btnbgcolor || '#1FBA30'};
  color: ${props => props.btntextcolor || 'white'};
  transition: all 0.25s ease;
  box-shadow: 0 3px 8px ${props => props.btnbgcolor ? props.btnbgcolor + '25' : '#1FBA3025'};
  
  &:hover {
    background: ${props => props.btnbghvcolor || '#1aa329'};
    transform: translateY(-1px);
    box-shadow: 0 5px 12px ${props => props.btnbgcolor ? props.btnbgcolor + '35' : '#1FBA3035'};
  }
`;

export const TabLinksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  border-top: 1px solid #f1f5f9;
  margin-top: 18px;
  padding-top: 14px;
  
  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const TabLink = styled.button`
  background: transparent;
  border: none;
  font-size: 12.5px;
  font-weight: 600;
  color: ${props => props.active ? (props.activeColor || "#1FBA30") : "#64748b"};
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  outline: none;
  
  &:hover {
    color: ${props => props.activeColor || "#1FBA30"};
  }
  
  svg {
    width: 14px;
    height: 14px;
    fill: currentColor;
  }
`;
